<template>
  <div>
    <div class="r-applications container position-relative">
      <h2 class="mb-5">Assign volume to region</h2>
      <table class="table table-bordered s-section-association-representative-table mb-5">
        <thead>
          <tr>
            <th scope="col">Year</th>
            <th scope="col">Source type</th>
            <th scope="col">Values</th>
            <th scope="col">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="sectorApplication in sectorApplications" :key="sectorApplication.id">
            <th scope="row">{{sectorApplication.year}}</th>
            <td class="align-middle">
              {{sectorApplication.source_type}}
            </td>
            <td class="align-middle">
              {{displayValues(sectorApplication.value)}}
            </td>
            <td class="align-middle">
              <span
                class="action-icon"
                @click="handleDelete(sectorApplication.id)"
              >
                <i class="fas fa-ban"></i>
              </span>
            </td>
          </tr>

        </tbody>
      </table>


      <form @submit.prevent="handleSubmit">
        <div class="d-flex justify-content-between">
            <div class="base-control base-checkbox form-group">
                <input
                  name="internal_external"
                  id="internal_volume"
                  v-validate="'required'"
                  class="styled-checkbox"
                  type="radio"
                  value="internal"
                  v-model="selectedType"
                  :disabled="getInternalRestValue === 0"
                >
                <label
                  style="font-weight: normal;"
                  class="mb-0"
                  for="internal_volume"
                >
                  Internal Pre-consumer waste (T)
                  <strong>({{getInternalRestValue}})</strong>
                </label>
            </div>
            <div class="base-control base-checkbox form-group">
                <input
                  name="internal_external"
                  id="external_volume"
                  v-validate="'required'"
                  class="styled-checkbox"
                  type="radio"
                  value="external"
                  v-model="selectedType"
                  :disabled="getExternalRestValue === 0"
                >
                <label
                  style="font-weight: normal;"
                  class="mb-0"
                  for="external_volume"
                >
                  Uptake of recyclate that is acquired from external sources
                  <strong>({{getExternalRestValue}})</strong>
                </label>
            </div>
        </div>
        <hr />
        <h3 class="text-center">
          {{$route.params.year}} -
          {{sumAdded}}/<strong>{{maxValue}}</strong>
        </h3>
        <hr />
        <div class="base-control pvc-tree">
          <div class="item-rect d-flex green" v-for="region in regions" :key="region">
            <div class="col-6">{{region}}</div>
            <div class="align-items-center col-6" style="justify-content: flex-end;" :class="{'deactivated': !isSubmissionSelected}">
              <div class="mr-0 d-flex align-items-center">
                <input
                  style="border-bottom:0; width:75px; border-bottom: 1px solid gray"
                  class="form-control simple pl-4 pr-1 text-right"
                  v-input-mask
                  v-model.lazy="tonnes[region]"
                  data-inputmask-mask="9{1,4}"
                  @change="handleInputChange(region)"
                  :disabled="!isSubmissionSelected"
                />
                <span class="pr-4">tonnes</span>
                <vue-slider
                  style="width: 100%;"
                  v-model.lazy="tonnes[region]"
                  :max="maxValue"
                  @change="handleSliderDragEnd(region)"
                  :ref="region"
                ></vue-slider>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-6 text-left">
              <base-button
                  radius="bl"
                  component-class="blue"
                  @click.native="$router.push({ name: 'user.manage-submission-sector-association-representative' })"
              ><i class="fas fa-arrow-left mr-3"></i> Previous
              </base-button>
          </div>
          <div class="col-6 text-right">
              <base-button
                  radius="br"
                  component-class="green filled"
                  type="submit"
                  :disabled="!isSubmittable"
              > Submit <i class="fas fa-arrow-right ml-3"></i>
              </base-button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex';
  import BaseButton from '@/components/inputs/button/BaseButton';
  import SectorSubmissionService from '@/services/SectorSubmission/SectorSubmission';
  import SectorApplicationService from '@/services/SectorApplication/SectorApplication';
  import { sumArray } from '@/helpers/math';
  import EventBus from '@/helpers/event-bus';
  import constances from '@/configs/constances';

  export default {
    data() {
      return {
        sectorApplications: [],
        groupedSectorSubmissions: [],
        company: {},
        tonnes: [],
        internalTotal: 0,
        externalTotal: 0,
        internalRestValue: 0,
        externalRestValue: 0,
        internalId: null,
        externalId: null,
        selectedType: null,
        selectedId: null,
        maxValue: 0,
        submittedData: {},
      };
    },

    computed: {
      ...mapState({
        countries: state => state.countries.countries,
      }),
      regions() {
        return constances.regions;
      },
      sumAdded() {
        return sumArray(Object.values(this.tonnes));
      },
      isSubmissionSelected() {
        return this.maxValue > 0;
      },
      isSubmittable() {
        return this.sumAdded > 0;
      },
      getInternalRestValue() {
        if (this.submittedData[this.$route.params.year]) {
          return this.internalTotal - this.submittedData[this.$route.params.year].internal;
        }
        return this.internalTotal;
      },
      getExternalRestValue() {
        if (this.submittedData[this.$route.params.year]) {
          return this.externalTotal - this.submittedData[this.$route.params.year].external;
        }
        return this.externalTotal;
      }
    },

    watch: {
      groupedSectorSubmissions: {
        handler(newValues) {
          if (newValues.length) {
            newValues.forEach((newValue) => {
              const { id, q1, q2, q3, q4 } = newValue;
              const total = sumArray([q1, q2, q3, q4]);
              if (newValue.source_type === 'internal') {
                this.internalId = id;
                // this.internalRestValue = total;
                this.internalTotal = total;
              }
              if (newValue.source_type === 'external') {
                this.externalId = id;
                // this.externalRestValue = total;
                this.externalTotal = total;
              }
            });
          }
        },
        deep: true,
      },
      sectorApplications: {
        handler(newValues) {
          if (Array.isArray(newValues)) {
            const sumAdded = {};
            newValues.forEach((newValue) => {
              const { source_type, value, year } = newValue;
              if (!sumAdded[year]) {
                sumAdded[year] = {
                  internal: 0,
                  external: 0,
                };
              }
              const objectValues = this.getValuesObject(value);
              sumAdded[year][source_type] += sumArray(Object.values(objectValues));
            });
            this.submittedData = sumAdded;
            this.$nextTick(() =>{
              this.maxValue = 0;
              this.selectedType = null;
            });
          }
        },
        deep: true,
      },
      selectedType(newValue) {
        if (newValue === 'internal') {
          this.selectedId = this.internalId;
          this.maxValue = this.getInternalRestValue;
          this.restTonnes();
        } else if (newValue === 'external') {
          this.selectedId = this.externalId;
          this.maxValue = this.getExternalRestValue;
          this.restTonnes();
        }
      }
    },

    methods: {
      ...mapActions({
        getUserSectorSubmissions: 'userSectorSubmissions/getUserSectorSubmissions',
        getCountries: 'countries/getCountries',
      }),
      restTonnes() {
        const tonnesKeys = Object.keys(this.tonnes);
        tonnesKeys.forEach(tonnesKey => {
          this.tonnes[tonnesKey] = 0;
        });
      },
      setRestValue(currentCountry) {
          setTimeout(() => {
            const addedValues = Object.keys(this.tonnes).filter(key => key !== currentCountry)
                                              .map(key => this.tonnes[key]);
            this.$refs[currentCountry][0].setValue(this.maxValue - sumArray(addedValues));
          }, 300);
      },
      handleInputChange(currentCountry) {
        if (this.sumAdded > this.maxValue) {
          this.setRestValue(currentCountry);
        }
      },
      handleSliderDragEnd(currentCountry) {
        if (this.sumAdded >= this.maxValue) {
          this.setRestValue(currentCountry);
        }
      },
      async handleSubmit() {
        try {
          const credentials = {
            sector_association_value_id: this.selectedId,
            value: {},
            year: this.$route.params.year,
            type: this.selectedType,
          };
          Object.keys(this.tonnes).forEach((key) => {
            const tonnesValue = this.tonnes[key];
            if (tonnesValue > 0) {
              credentials.value[key] = tonnesValue;
            }
          });
          const response = await SectorApplicationService.save(credentials);
          EventBus.$emit('snotifySuccess', 'Application added.');
          this.restTonnes();
          if (response) {
            window.scroll({
              top: 0,
              behavior: 'smooth'
            });
            this.sectorApplications = response['data'];
          }
        } catch (error) {
          if (error.response.data.errors.length) {
            EventBus.$emit('snotifyError', error.response.data.errors[0].msg);
          }
        }
      },
      async handleDelete(id) {
        const response = await SectorApplicationService.delete(id);
        EventBus.$emit('snotifySuccess', 'Application deleted.');
        if (response) {
          this.sectorApplications = response['data'];
        }
      },
      getValuesObject(values) {
        let jsonValues = values;
        if (typeof values === 'string') {
          jsonValues = JSON.parse(values);
        }
        return jsonValues;
      },
      displayValues(values) {
        const jsonValues = this.getValuesObject(values);
        return Object.keys(jsonValues).map((key) => {
          return `${key}: ${jsonValues[key]}`;
        }).join(', ');
      }
    },

    async mounted() {
      const { data } = await SectorSubmissionService.getSectorSubmission(this.$route.params.year);
      this.groupedSectorSubmissions = data;
      const response = await SectorApplicationService.index();
      this.sectorApplications = response['data'] || [];
      await this.getCountries();
    },

    components: {
      'base-button': BaseButton,
    }
  };
</script>

<style lang="scss">
  .deactivated {
    opacity: 0.5;
  }
</style>